import moment from "moment";

import "moment/locale/de";
import "moment/locale/en-gb";

function capitalizeFirstLetter(string: string): string {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getDateTimeFormat = (language: string): string => {
  return language === "en" ? "YYYY MMMM D - h:mm A" : "YYYY MMMM D - h:mm";
};

export const formatRelativeDateTime = (
  dateTimeString: string,
  language: string,
): string => {
  if (!dateTimeString) {
    return "";
  }

  const trimmedDateTimeString = dateTimeString.trim();

  const dateTime = moment.utc(trimmedDateTimeString);
  const today = moment.utc().startOf("day");
  const yesterday = moment.utc().subtract(1, "days").startOf("day");

  moment.locale(language);

  if (dateTime.isSame(today, "day") || dateTime.isSame(yesterday, "day")) {
    const dayFormatted = moment.utc(trimmedDateTimeString);
    return capitalizeFirstLetter(`${dayFormatted.calendar()} UTC`);
  } else {
    const dateFormat = getDateTimeFormat(language);
    return `${dateTime.format(dateFormat)} UTC`;
  }
};
